import { OidcClient } from '@axa-fr/react-oidc';
import { v4 as uuid } from 'uuid';

import type { SourceAppViewType } from '@shared/constants/constants';
import { LayoutViewBridge } from '@shared/context';

import { API_KEY } from './URL';

const CONTENT_TYPE = 'application/json';

const getRequestOptions = (
  withCredentials: boolean,
  IsIncludeClientMessageId = true,
  customSourceApp?: SourceAppViewType
) => {
  const guid = uuid();
  const oidc = OidcClient.get();
  const { sourceAppView } = LayoutViewBridge.getLayoutViewBridge?.() ?? {};

  return {
    headers: {
      'Content-Type': CONTENT_TYPE,
      'X-Api-Key': API_KEY,
      'X-HH-Agent': navigator.userAgent,
      'X-HH-SourceApp': customSourceApp ?? sourceAppView,
      ...(IsIncludeClientMessageId && { 'X-HH-MessageId': guid }),
      ...(oidc.tokens?.accessToken && { Authorization: `Bearer ${oidc.tokens?.accessToken}` }),
    },
    withCredentials,
  };
};

export { getRequestOptions };
